import { Typography } from "@mui/material";
import Section from "../../../components/section/section";
import React from "react";
import CoachListProps from "./interface/coachListProps";
import RenderList from "./src/renderList";
import EditCoachProps from "./interface/editCoachProps";
import EditCoachDialog from "./src/editCoach/editCoachDialog";
import RenderTopBar from "./src/renderTopBar";
import AddCoachDialog from "./src/addCoach/addCoachDialog";
import { CoachListContext } from "./context/coachListContext";

const CoachListContainer = (): React.JSX.Element => {
  const {
    coachList,
    editCoach,
    addCoach,
  }: {
    coachList: CoachListProps;
    editCoach: EditCoachProps;
    addCoach: boolean;
  } = React.useContext(CoachListContext);

  if (coachList.loading)
    return (
      <Section>
        <Typography variant="h4">Lade Coachs...</Typography>
      </Section>
    );

  return (
    <Section>
      <RenderTopBar />
      <RenderList />

      {editCoach.showDialog && <EditCoachDialog />}
      {addCoach && <AddCoachDialog />}
    </Section>
  );
};

export default CoachListContainer;
